import HttpResponse from "../../../../../utils/http/http.response";

export enum DriverContractsListResponseDataModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type DriverContractsListResponseData = {
  contractId: string;
  validSince: string;
  validTo: string;
  model: DriverContractsListResponseDataModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  companyName: string;
  active: boolean;
};

type DriverContractsListResponse = HttpResponse<
  DriverContractsListResponseData[]
>;

export default DriverContractsListResponse;
